module.exports = __webpack_public_path__ + "img/logo-binus.f716d484.png";